<template>
  <SearchableModel
    model-name="ProductTest"
    :base-filters="props.baseFilters"
    :available-filters="availableFilters"
    :with-export="withExport"
    :push-state="pushState"
    ref="searchableModelRef"
    :class="props.className"
  >
    <template #header-title>
      <slot name="header-title" />
    </template>
    <template #header-actions>
      <slot name="header-actions" />
    </template>
    <template #default="{ models }">
      <ProductTestIndexTable v-if="models"
                    :show-product="showProduct"
                    :show-equipment="showEquipment"
                    :show-tour="showTour"
                    :show-registration="showRegistration"
                    :show-comment="showComment"
                    :product-tests="models"
                    :with-export="true"
                    @refresh="getResults" />
    </template>
  </SearchableModel>
</template>

<script setup>
import { onMounted, ref } from "vue";
import {on as onEvent} from '../../eventBus.js';

import ProductTestIndexTable from "./ProductTestIndexTable.vue";
import SearchableModel from "@/components/searchable-model/SearchableModel.vue";

// Props
const props = defineProps({
  baseFilters: {
    type: Object,
  },
  availableFilters: {
    type: Array,
    default: () => [],
  },
  showProduct: {
    type: Boolean,
    default: false,
  },
  showEquipment: {
    type: Boolean,
    default: false,
  },
  showTour: {
    type: Boolean,
    default: false,
  },
  showRegistration: {
    type: Boolean,
    default: false,
  },
  showComment: {
    type: Boolean,
    default: false,
  },
  withExport: {
    type: Boolean,
    default: false,
  },
  pushState: {
    type: Boolean,
    default: false,
  },
  className: {
    type: String,
    default: null,
  },
})

// Reactive data
const searchableModelRef = ref(null)

// Methods
const getResults = () => {
  if (searchableModelRef.value) {
    searchableModelRef.value.refresh()
  }
}

onMounted(() => {
  onEvent('start', () => getResults())
})

</script>
